<template>
    <div>
        <door-leaf-opening-side> </door-leaf-opening-side>
        <v-divider class="my-5"></v-divider>
        <door-leaf-counter-opening-side> </door-leaf-counter-opening-side>
        <v-divider class="my-5"></v-divider>
        <gloss />
        <v-divider class="my-5"></v-divider>
        <veneer /><v-divider class="my-5"></v-divider>
    </div>
</template>
<script>
import Vue from 'vue';  
import DoorLeafOpeningSide from './DoorLeafOpeningSide.vue';
import DoorLeafCounterOpeningSide from './DoorLeafCounterOpeningSide.vue';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import Gloss from "./Gloss";
import Veneer from "./Veneer";
export default Vue.extend({
    name: 'DoorLeaf',
    components: {
        'door-leaf-opening-side' : DoorLeafOpeningSide,
        'door-leaf-counter-opening-side' :  DoorLeafCounterOpeningSide,
        'gloss': Gloss,
        'veneer': Veneer
    },
    props: {
        characteristic: Object,            
    },
    data() {
            return {
                
            }
        },
        computed: {            
            // ...mapGetters(['getCurrentDoorConfiguration']),
            // ...mapGetters('measureModule', [ 'getCharacteristicAndValues', 'getNrOfValuesByCharacteristic', 'checkRadioValue' ]),
        },
        methods: {
            // ...mapActions(['updateDoorConfiguration']),
            // ...mapActions('measureModule', ['addCharacterisitc']),
        }, 
        mounted() {
            
        }
});
</script>